import React from "react";
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';





class TokenCheck extends React.Component {
    constructor(props){
        super(props);
        this.state={
          tokenCheck:true,
        }
      }
      componentWillMount=()=>{
        this.tokenExpiryCheck()
      }
      tokenExpiryCheck=()=>{
        const token = localStorage.getItem('authToken');
        return new Promise(resolve=>{
            console.log("token check req",kinetik_api_url+'/tokenCheck?token='+token);
          axios.get(kinetik_api_url+'/tokenCheck?token='+token).then((res)=>{
            console.log("res from token Check",res)
            if(res.data.status!=='success'){
              this.setState({tokenCheck:false})
            }
            resolve();
          })
        })
      }
   
       
  render=()=> {
    if(this.state.tokenCheck===false || localStorage.getItem('authToken') === null){
        return <Redirect to="/logout" />
         }
    
      return (
        <div>
        </div>
      );
  }
}



export default TokenCheck;



// WEBPACK FOOTER //
// ./src/app/common/TokenCheck.js